var CryptoJS = require("crypto-js");

const merchantKey = '025ca5a7857547255f4ba97510ee2d631e1d79469a21048e197029ca11fac02c';
const merchantId = 'fa515ac8f0ce5fc27f7a102d05234ea9';
// const merchantKey = process.env.REACT_APP_MERCHANT_KEY;
// const merchantId = process.env.REACT_APP_MERCHANT_ID;
function generateNonce() {
  return Math.random().toString(36).substring(2); // Random string
}

function generateSignature(queryString, merchantKey) {
  const hmac = CryptoJS.HmacSHA256(queryString, merchantKey);
  return CryptoJS.enc.Base64.stringify(hmac);
}

function sortObject(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}

export default async function getSignature() {
  const myToken = localStorage.getItem("authToken");
  try {
    const timestamp = Math.floor(Date.now() / 1000);
    const nonce = generateNonce();
    const params = {
      "x-api-key": merchantId,
      "X-Timestamp": timestamp,
      "X-Nonce": nonce,
    };

    const sortedParams = sortObject(params);
    const queryString = new URLSearchParams(sortedParams).toString();
    const signature = generateSignature(queryString, merchantKey);
    // console.log("signature",signature)

    const headers = {
      // "Content-Type": "application/x-www-form-urlencoded",
      // "Content-Type": "application/json",
      "x-api-key": merchantId,
      "X-Timestamp": timestamp,
      "X-Nonce": nonce,
      "X-Sign": signature,
      // authorization: myToken,
    };
    return headers;
  } catch (e) {
    // console.log(e);
  }
}
